export default __webpack_public_path__ + "static/media/logo.715985a2.svg";